import { useState, useEffect } from 'react';
import { toast } from 'sonner';

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(false);
      toast.success('You\'re back online!', { 
        duration: 3000,
        description: 'Your connection has been restored.'
      });
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
      toast.error('No internet connection', {
        duration: Infinity,
        description: 'Please check your network connection. The app will resume when you\'re back online.',
        dismissible: true,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline, showBanner };
}